export default "__VITE_ASSET__BCIgEh47__"